export const AUTOPASTE_EXTENSION_SOURCE = 'fishhunter-autopaste-extension';
export const AUTOPASTE_APP_SOURCE = 'fishhunter-app';

export const AUTOPASTE_EXTENSION_MESSAGE = {
  SEARCH: 'AUTOPASTE_SEARCH',
  STATS: 'AUTOPASTE_STATS',
  ENABLED_CHANGED: 'AUTOPASTE_ENABLED_CHANGED',
} as const;

const POKERSITE_IDS = new Set([1, 2, 3, 4, 5, 6]);

export function notifyAutopasteExtension(enabled: boolean) {
  window.postMessage(
    {
      source: AUTOPASTE_APP_SOURCE,
      type: AUTOPASTE_EXTENSION_MESSAGE.ENABLED_CHANGED,
      enabled,
    },
    window.location.origin,
  );
}

export function isAutopasteExtensionMessage(data: unknown): data is {
  source: typeof AUTOPASTE_EXTENSION_SOURCE;
  type: typeof AUTOPASTE_EXTENSION_MESSAGE.SEARCH;
  nickname: string;
} {
  if (!data || typeof data !== 'object') {
    return false;
  }

  const message = data as Record<string, unknown>;

  return (
    message.source === AUTOPASTE_EXTENSION_SOURCE &&
    message.type === AUTOPASTE_EXTENSION_MESSAGE.SEARCH &&
    typeof message.nickname === 'string' &&
    message.nickname.length > 0
  );
}

export function isAutopasteExtensionStatsMessage(data: unknown): data is {
  source: typeof AUTOPASTE_EXTENSION_SOURCE;
  type: typeof AUTOPASTE_EXTENSION_MESSAGE.STATS;
  playername: string;
  pokersiteId: 1 | 2 | 3 | 4 | 5 | 6;
} {
  if (!data || typeof data !== 'object') {
    return false;
  }

  const message = data as Record<string, unknown>;

  return (
    message.source === AUTOPASTE_EXTENSION_SOURCE &&
    message.type === AUTOPASTE_EXTENSION_MESSAGE.STATS &&
    typeof message.playername === 'string' &&
    message.playername.length > 0 &&
    POKERSITE_IDS.has(message.pokersiteId as number)
  );
}
